export default [{
        path: '/blogs',
        name: 'blogs',
        component: () =>
            import ('@/views/modules/blogs/blogs-list/BlogsList.vue'),
        meta: {
            resource: 'ACL',
            pageTitle: 'Blog',
            breadcrumb: [{
                text: 'Lista de blogs',
                active: true
            }],
            requiresAuth: true
        }
    },
    {
        path: '/blog/create',
        name: 'blogs-create',
        component: () =>
            import ('@/views/modules/blogs/blogs-store/BlogStore.vue'),
        meta: {
            resource: 'ACL',
            pageTitle: 'Blog',
            breadcrumb: [{
                text: 'Lista de blogs',
                to: { name: 'blogs' }
            }, {
                text: 'Nuevo blog',
                active: true
            }],
            requiresAuth: true
        }
    },
    {
        path: '/blog/:id/edit',
        name: 'blogs-edit',
        component: () =>
            import ('@/views/modules/blogs/blogs-edit/BlogsEdit.vue'),
        meta: {
            resource: 'ACL',
            pageTitle: 'Blog',
            breadcrumb: [{
                text: 'Lista de blogs',
                to: { name: 'blogs' }
            }, {
                text: 'Editar blog',
                active: true
            }],
            requiresAuth: true
        }
    }
]
